<template>
	<div class="mainLeft">
		<recommend :data="data"/>
		<newRelease :arr="data2"/>
	</div>
</template>

<script>
	import recommend from './recommend'
	import newRelease from './newRelease'
	
	import axios from '@/axios/'
	
	export default{
		components:{
			recommend,newRelease
		},
		data(){
			return{
				data:[],	//特别推荐
				data2:[],	//最新发布
			}
		},
		async created(){
			try{
				//特别推荐
				let {data} = await axios('/index/recommend');
				if (data.code == 200) {
					this.data = data.data;
				}
			}catch(e){
				//
			}
			try{
				//最新发布
				let {data} = await axios('/index/newrelease');
				if (data.code == 200) {
					this.data2 = data.data;
				}
			}catch(e){
				//
			}
		}
	}
	
</script>

<style scoped>
	.mainLeft{
		width: 950px;
		float: left;
	}
</style>
